import { type ModuleData, ModuleProvider, useModule } from '#providers'
import {
	ApplicantDto,
	ConsentRequestDto,
	EskatCompletedEvent,
} from './Eskat.types'

interface EskatConfig {
	environment: string
	getConsent: (inputs?: { useDemo: boolean }) => Promise<ConsentRequestDto>
	fetchAndPersistEskatData: () => Promise<void>
	getApplicantsByCaseId: (caseId: string) => Promise<ApplicantDto[]>
	postTestData: (demoProfile: string | null) => Promise<void>
	openPopup: (eskatFormRef: React.RefObject<HTMLFormElement>) => void
	registerEskatMessageListener: (
		handler: (event: EskatCompletedEvent) => Promise<void>,
	) => () => void
}

interface EskatData {
	caseId: string
	applicantId: string
	applicantSessionId: string
	applicantSessionQuestionnaireHashedCpr: string | null
	applicantClientInputHashedCpr: string | null
	clientId: number
	isFinished: boolean
}

export type EskatModuleData = ModuleData<EskatData, void, EskatConfig>

export const EskatModuleProvider: typeof ModuleProvider<EskatModuleData> =
	ModuleProvider

export const useEskatModule: typeof useModule<EskatModuleData> = useModule
